import NumberUtils from 'frontools/utils/NumberUtils';  

/**
 * Dummy class which helps to give the blood cell's position and which group it belongs to.
 */
export class BloodCellPosition {

    private _column      :      number; // One indexed; Used to specify which column the first blood cell of each group will start.
    private _index       :      number = 0; // Zero indexed blood cell index in the current group.
    private _group       :      number; // One indexed; Used to specify if blood cell is in a 1, 2 or 3 blood cells group.

    constructor() {
        // Get first position.
        this._generate();
    }

    public getColumn(): number {
        if (this._index + 1 == this._group) {
            // Starts a new group.
            this._generate();
        } else {
            this._index += 1;
        }
        return this._column;
    }

    /**
     * Generate column position and blood cell group.
     * We don't want the new column to be the same as the old one.
     */
    private _generate() {
        this._index = 0;
        let column = NumberUtils.random(1, 4);
        while (this._column == column) {
            column = NumberUtils.random(1, 4);
        }
        this._column = column;
        this._group = NumberUtils.random(1, 3);
    }
}